export const BASE_URL = process.env.REACT_APP_API_URL;
export const CF_URL = process.env.REACT_APP_CLOUDFLARE_API_URL;
